import { toast } from "react-toastify";

import {
  fetchBPROneRequest,
  fetchBPROneSuccess,
  fetchBPROneFailure,
} from "./reducer";

import { GET_ALL_BPR_ONE } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getAllBPROne =
  (first = 10, offset = 1, startDate, endDate, setLoading) =>
  async (dispatch) => {
    dispatch(fetchBPROneRequest());

    try {
      setLoading?.(true);
      const payload = {
        query: `query {
          stationConnectorSummary(
            first: ${first},
            offset: ${offset},
            filter: {
              fromDate: "${startDate}",
              toDate: "${endDate}"
            }
          ) {
            totalStations
            totalConnectors
            totalStationsOnboard
            partners {
              partnerId
              totalStations
              totalConnectors
              totalStationsOnboard
            }
          }
        }`,
      };

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_BPR_ONE,
        "POST",
        payload,
      );

      if (response?.error) {
        dispatch(fetchBPROneFailure(response.error.message));
        toast.error(response.error.message);
        return;
      }

      dispatch(fetchBPROneSuccess(response));
    } catch (error) {
      dispatch(fetchBPROneFailure(error?.message || "Something went wrong"));
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading?.(false);
    }
  };
